export default __webpack_public_path__ + "static/media/submit.50fcfb9e.svg";